import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-healthsytemform',
  templateUrl: './healthsytemform.component.html',
  styleUrls: ['./healthsytemform.component.scss']
})
export class HealthsytemformComponent implements OnInit {

  constructor(private _snackBar: MatSnackBar) { }

  ngOnInit() {
  }


  displayMessage(){
    const msg = ['A Appy Health Representative will contact you shortly.', 'Thank you', 'The Appy health Team'];
    this._snackBar.open(' A Appy Health Representative will contact you shortly.', 'Thank You.' ,{
    duration: 7000,
    verticalPosition: 'top',
    horizontalPosition: 'right',
    panelClass : ['blue-snackbar']
    
    });
  }
}
